var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevoked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,0,1,3.514,3.514,12,12,0,0,1,20.486,20.486,11.922,11.922,0,0,1,12,24ZM12,1.688A10.316,10.316,0,0,0,7.988,21.5a10.314,10.314,0,0,0,11.3-16.8A10.268,10.268,0,0,0,12,1.688Zm4.215,15.385a.831.831,0,0,1-.6-.248L12,13.195,8.384,16.821a.844.844,0,0,1-1.441-.592.84.84,0,0,1,.246-.6L10.809,12,7.188,8.369a.843.843,0,1,1,1.2-1.19L12,10.8l3.617-3.625a.842.842,0,1,1,1.193,1.19L13.19,12l3.622,3.633a.844.844,0,0,1-.6,1.439Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevoked);
export default __webpack_public_path__ + "static/media/revoked.7be71680.svg";
export { ForwardRef as ReactComponent };